<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
import {
  hmdgl_page,
  hmdgl_detail,
  hmdgl_save,
  hmdgl_updateBlankList,
  hmdgl_suppliersave,
  hmdgl_list,
  hmdgl_updateLabel,
  hmdgl_violationDetail,
  hmdgl_executedDetail,
  hmdgl_comapny,
  groupList,
  hmdgl_saveCompany,
  hmdgl_deletes,
  hmdgl_init,
  hmdgl_dantsjcx,
  hmdgl_updateCompany, hmdgl_gysfxcx
} from '../../../../api/hmdgl.js';
import { forEach } from 'core-js/modules/_enum-bug-keys';
export default {
	name: 'hmdgl',
	components: {},
	data: function() {
		return {
			filterText: '',
			data: [],
			defaultProps: {
				children: 'children',
				label: 'name'
			},
			yangqing: {
				managements: {
					now: [],
					history: []
				},
				executions: {
					now: [], //现在
					history: [], //历史
					executedPeron: [],
					violations: []
				},
				majorTaxes: {
					majorTaxes: []
				}
			},
			province:getdata().province,
			allowDrag: null,
			allowDrop: null,
			glwfgs: false,
			shaidiag: false,
			searchdata: getdata().searchdata,
			searchlist: getdata().searchlist,
			outlist: [],
			headData: getdata().headData,
			pagination: getdata().pagination,
			tableData: [],
			searchdiag: false,
			formlist: getdata().formlist,
			formdata: getdata().formdata,
			lrdetail: false,
			ywflxsz: false,
			options: [],
			value: '',
			num: 1,
			hmddiag: false,
			formlisthmd: getdata().formlisthmd,
			formdatahmd: getdata().formdatahmd,
			szData: [
				{
					label: ''
				}
			],
			addywfdiag: false,
			detaildiag: false,
			jydiag: false,
			yzdiag: false,
			sxsmdiag: false,
			zdsmdiag: false,
			zddiag: false,
			tablekey: 0,
			overlength: 0,
			managements: [],
			violationDetail: {},
			executedDetail: {},
			xuanzongdsju: [],
			headDatags: getdata().headDatags,
			title: '手工录入',
			id: ''
		};
	},

	mounted() {},
	created() {
		this.jibenxxfenyechaxun();
		this.initHander();
	},
	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		}
	},
	methods: {	  geOoverLength(e){
		  this.overlength = e;
		 
	  },
		yewfnagfxcx() {
			// hmdgl_init().then(res => {
			// 	if (res.data.code == 1) {
			// 		this.$message.success(res.data.data);
			// 		this.pagination.pageNum = 1;
			// 		this.pagination.paginationkey++;
			// 		this.jibenxxfenyechaxun();
			// 	} else {
			// 		this.$message.error(res.data.msg);
			// 	}
			// });
      if (this.$refs.tablebox.getSelectionval().length == 0) {
        this.$message.error('请选择要操作的数据');
      } else {
        let params = this.$refs.tablebox.getSelectionval().map(v => v.supplierTaxNumber);
        hmdgl_gysfxcx(params).then(res => {
          if (res.data.code == 1) {
            this.$message.success(res.data.data);
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.jibenxxfenyechaxun();
          } else {
            this.$message.error(res.data.msg);
          }
        })
      }
		},
		shanchu() {
			if (this.$refs.tablebox.getSelectionval().length == 0) {
				this.$message.error('请选择要删除的数据');
			} else {
				this.$showConfirm({
					message: '确认删除?'
				}).then(res => {
					if (res == 'confirm') {
						let params = this.$refs.tablebox.getSelectionval().map(v => v.id);
						hmdgl_deletes(params).then(res => {
							if (res.data.code == 1) {
								this.$message.success(res.data.data);
								this.pagination.pageNum = 1;
								this.pagination.paginationkey++;
								this.jibenxxfenyechaxun();
							} else {
								this.$message.error(res.data.msg);
							}
						});
					}
				});
			}
		},
		modification() {
			this.id = '';
			if (this.$refs.tablebox.getSelectionval().length == 0) {
				this.$message.error('请选择数据');
			} else if (this.$refs.tablebox.getSelectionval().length > 1) {
				this.$message.error('只能选择一条数据');
			} else {
				this.title = '手工修改';
				let params = { id: this.$refs.tablebox.getSelectionval().map(v => v.id) };
				hmdgl_dantsjcx(params).then(res => {
					if (res.data.code == 1) {
						this.xuanzongdsju = res.data.data.companyListOutputDTOS.map(v => {
							return {
								companyCode: v.companyCode,
								name: v.companyNam,
								id: v.deptId
							};
						});
						this.formdata.supplierName = res.data.data.supplierName;
						this.formdata.supplierTaxNumber = res.data.data.supplierTaxNumber;
						this.id = res.data.data.id;
						this.lrdetail = true;
					}
				});
				// this.cxdqgsbplb();
			}
		},
		sgrrlqud() {
			if (this.formdata.supplierName == '' || this.formdata.supplierTaxNumber == '' || this.xuanzongdsju.length == 0) {
				this.$message.error('请选择数据');
			} else {
				let params = {
					companyList: this.xuanzongdsju.map(v => v.id),
					supplierName: this.formdata.supplierName,
          supplierTaxNumber: this.formdata.supplierTaxNumber,
					id: this.id
				};
				if (this.id == '') {
					hmdgl_saveCompany(params).then(res => {
						if (res.data.code == 1) {
							this.$message.success(res.data.data);
							this.lrdetail = false;
							this.pagination.pageNum = 1;
							this.pagination.paginationkey++;
							this.jibenxxfenyechaxun();
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else {
					hmdgl_updateCompany(params).then(res => {
						if (res.data.code == 1) {
							this.$message.success(res.data.msg);
							this.lrdetail = false;
							this.pagination.pageNum = 1;
							this.pagination.paginationkey++;
							this.jibenxxfenyechaxun();
						} else {
							this.$message.error(res.data.msg);
						}
					});
				}
			}
		},
		tixiao() {
			if (this.$refs.tree.getCheckedNodes().length != 0) {
				let xuanzsj = this.$refs.tree.getCheckedNodes();
				let xuanzongdsju = [];
				this.xuanzongdsju = [];
				xuanzsj.forEach(v => {
					function_name(v);
				});

				function function_name(v) {
					if (v.children.length == 0) {
						xuanzongdsju.push(v);
					}
				}
				this.xuanzongdsju = xuanzongdsju;
				this.glwfgs = false;
			} else {
				this.$message.error('请选择公司');
			}
		},
		filterNode(value, data) {
			if (!value) return true;
			return data.name.indexOf(value) !== -1;
		},
		glwfgstankiuang() {
			this.glwfgs = true;
			groupList().then(res => {
				if (res.data.data) {
					this.data = res.data.data;
					this.glwfgs = true;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		sxsmdiagtankuang(id) {
			let params = {
				id: id
			};
			hmdgl_executedDetail(params).then(res => {
				if (res.data.code == '1') {
					this.executedDetail = res.data.data;
					// this.violationDetail.unitForInspection=unitForInspection;
					this.sxsmdiag = true;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		zdsmdiagtankuang(id, unitForInspection) {
			let params = {
				id: id
			};
			hmdgl_violationDetail(params).then(res => {
				if (res.data.code == '1') {
					this.violationDetail = res.data.data;
					this.violationDetail.unitForInspection = unitForInspection;

					this.zdsmdiag = true;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		zddiagtankuang(e) {
			if (e.length == 0) {
				// this.$message.info('没有重大税收违法风险');
			} else {
				this.zddiag = true;
			}
		},
		yzdiagtankuang(e) {
			if (e.length == 0) {
				// this.$message.info('没有经营异常风险2');
			} else {
				this.yzdiag = true;
			}
		},
		ywjyycfx(e) {
			if (e.length == 0) {
				// this.$message.info('没有经营异常风险');
			} else {
				this.managements = e;
				this.jydiag = true;
			}
		},
		ywflxszbc() {
			let params = {
				ids: this.$refs.tablebox.getSelectionval().map(v => v.id),
				label: this.value
			};
			hmdgl_updateLabel(params).then(res => {
				if (res.data.code == '1') {
					this.$message.success(res.data.data);
					this.ywflxsz = false;
					this.pagination.pageNum = 1;
					this.pagination.paginationkey++;
					this.jibenxxfenyechaxun();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		ywfsz() {
			if (this.$refs.tablebox.getSelectionval().length == 0) {
				this.$message.error('请选择数据');
			} else {
				this.cxdqgsbplb();
				this.ywflxsz = true;
			}
		},
		cxdqgsbplb() {
			this.options = [];
			this.value = '';
			hmdgl_list().then(res => {
				if (res.data.code == '1') {
					this.options = JSON.parse(JSON.stringify(res.data.data));
				} else {
					this.options = [];
				}
			});
		},

		initHander() {
			hmdgl_list().then(res => {
				if (res.data.code == '1') {
					let options = JSON.parse(JSON.stringify(res.data.data));
					let sl = this.searchlist;
					let s = {};
					for (let i = 0; i < sl.length; i++) {
						if (sl[i].prop == 'type') {
							s = sl[i];
							break;
						}
					}
					s.selectval = [];
					for (let y = 0; y < options.length; y++) {
						let obj = {
							value: options[y].supplierLabel,
							label: options[y].supplierLabel
						};
						s.selectval.push(obj);
					}
					this.searchlist = JSON.parse(JSON.stringify(this.searchlist));
				}
			});
		},
		bianjywlx() {
			if (this.options.length == 0) {
				this.szData = [
					{
						label: ''
					}
				];
			} else {
				this.szData = this.options.map(v => {
					return {
						label: v.supplierLabel
					};
				});
			}
			this.addywfdiag = true;
		},
		ywflxplbc() {
			this.szData.forEach(v => {
				if (v.label == '' || v.label == null) {
					this.$message.error('请填写业务数据');
					boo = false;
				}
			});
			let params = {
				labels: this.szData.map(v => v.label)
			};
			hmdgl_suppliersave(params).then(res => {
				if (res.data.code == '1') {
					this.$message.success(res.data.data);
					this.cxdqgsbplb();
					this.addywfdiag = false;
				} else {
					this.$message.success(res.data.msg);
				}
			});
		},
		chakanxiangqing(e) {
			let params = {
				id: e
			};
			hmdgl_detail(params).then(res => {
				if (res.data.code == 1) {
					this.yangqing = res.data.data;
					this.detaildiag = true;
				} else {
					this.$message.success(res.data.msg);
				}
			});
		},
		jibenxxfenyechaxun() {
			let params = {};
			params = JSON.parse(JSON.stringify(this.searchdata));
			params.current = this.pagination.pageNum;
			params.size = this.pagination.pageSize;
			params.sort = '';
			params.order = '';
			hmdgl_page(params).then(res => {
				this.pagination.total = res.data.data.total;
				this.tableData = res.data.data.records;
				if (res.data.data == null) {
					this.tableData = [];
				}
			});
		},
		handleCommand(command) {
			if (command == 'insert') {
				this.id = '';
				this.title = '手工录入';
				this.xuanzongdsju = [];
				this.formdata = {
					supplierName: '',
          supplierTaxNumber: ''
				};
				this.lrdetail = true;
			} else if (command == 'syncdata'){
          hmdgl_init({}).then(res =>{
            if(res.data.code == 1){
              this.jibenxxfenyechaxun();
              this.$message.success(res.data.msg);
            } else {
              this.$message.error(res.data.msg);
            }
          })
      }
		},
		yrychmd() {
			if (this.$refs.tablebox.getSelectionval().length == 0) {
				this.$message.error('请选择数据');
			} else {
				this.hmddiag = true;
				this.formdatahmd = {
					isBlack: '',
					includeReason: ''
				};
			}
		},
		forsubmit() {
			if (this.$refs.tablebox.getSelectionval().length == 0) {
				this.$message.error('请选择数据');
			} else {
				if(this.formdatahmd.isBlack==""){
					this.$message.error('请选择移入或移出');
					return;
				}
				if(this.formdatahmd.includeReason.length==0){
					this.$message.error('请将字段填写完整在进行保存');
					return;
				}
				if(this.formdatahmd.includeReason.length>100){
					this.$message.error('请输入0-100个字符');
					return;
				}
				let date = {};
				date = this.formdatahmd;
				date.ids = this.$refs.tablebox
					.getSelectionval()
					.map(v => v.id);
				hmdgl_updateBlankList(date).then(res => {
					if (res.data.code == '1') {
						this.$message.success(res.data.data);
						this.hmddiag = false;
						this.pagination.pageNum = 1;
						this.pagination.paginationkey++;
						this.jibenxxfenyechaxun();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			}
		},
		getdata(data) {
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.jibenxxfenyechaxun();
		},
		currentChange(e) {
			this.pagination.pageNum = e;
			this.jibenxxfenyechaxun();
		},
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.jibenxxfenyechaxun();
		},
		forRefresh() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.jibenxxfenyechaxun();
		},

		forUpdateSearch() {
			this.searchdiag = true;
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		},
		addline() {
			this.szData.push({});
		},
		spliceywfdiag(index) {
			this.szData.splice(index, 1);
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
